import { render, staticRenderFns } from "./Livello-utente.vue?vue&type=template&id=2d74210d&scoped=true&"
import script from "./Livello-utente.vue?vue&type=script&lang=js&"
export * from "./Livello-utente.vue?vue&type=script&lang=js&"
import style0 from "./Livello-utente.vue?vue&type=style&index=0&id=2d74210d&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d74210d",
  null
  
)

export default component.exports